<template>
  <div>
    <h1>Our Products & Services</h1>
    <table id="projects">
      <!--<tr>-->
        <!--<td>Name</td>-->
        <!--<td>Status</td>-->
      <!--</tr>-->
      <tr>
        <th><h2 style="width: auto">private car charter and tour marketplace platform</h2></th>
        <td><h2>Under Development</h2></td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld'
}
</script>

<style scoped>
#projects {
  width: 100%;
  border-collapse: collapse;
}

#projects th {
  text-align: left;
}

#projects td {
  text-align: center;
}

#projects th, #projects td {
  border: 1px solid
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue